import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect';
import isEmpty from 'lodash/isEmpty';
import { createPortal } from 'react-dom';
import HomeTeam from './components/HomeTeam';
import AwayTeam from './components/AwayTeam';
import img from '../../../../../../assets/img/angels-cup.png';
import SwitchToggle from '../../../../../../components/SwitchToggle';
import { PlayerInfoPopupView, TeamInfoPopup } from '../../../../../../components/Popup';
import LiveMatchBar from '../LiveMatchBar';
import ConfirmMatch from '../ConfirmMatchButton';
import {
  getOpponentStrategy,
  getOpponentSquad,
  myTeamTactic,
  getStrategyTactics,
  getOpponentTeamName,
  isFormationLoading,
  isAutoFormatEnabled,
  getCurrentMatchRunning,
  getCurrrentMatchDiscordChannel,
} from '../../../../../../redux/selector/Team';
import { getPopupByName } from '../../../../../../redux/selector/Popups';
import { isAuth, isPremiumUser } from '../../../../../../redux/selector/User';
import { getPlayerInformationSelector } from '../../../../../../redux/selector/League';
import {
  setAutoFormation,
  removePlayerFromStaff,
} from '../../../../../../redux/actions/Team';

import {
  compactFieldSrc,
  tallFieldSrc,
  StyledReactTooltip,
  StyledInfoDark,
} from './styled';
import { POPUPS, STRATEGY_NAMES } from '../../../../../../service/constants';
import { showPopupWindow } from '../../../../../../redux/actions/Popups';
import { isMatchLive } from '../../../../../../service/liveMatch';

import StrategyToolbar from '../StrategyToolbar';
import CaptainPanel from '../CaptainPanel';
import ChrisWand from '../ChrisWand';
import StrategyPresets from '../StrategyPresets';
import HomeCalendar from '../../../../../Home/components/HomeCalendar';
import { upcomingCalendarList, isStrategyLoading } from '../../../../../../redux/selector/Team';
import { getMyCurrentTeam } from '../../../../../../redux/selector/User';
import { Header, Actions, Delegate, Pitch, Clear, Fixtures, PitchActions, FormationViewTabs } from '../../layout';
export default function GameFields({ MyStrategy, MyTeam, activeDraggingId }) {
  const { PLAYER_INFO_POPUP_VIEW, TEAM_INFO_POPUP } = POPUPS;
  const isAutoFormationEnabled = useSelector(isAutoFormatEnabled);

  const OpponentTeam = useSelector(getOpponentSquad);
  const OpponentStrategy = useSelector(getOpponentStrategy);
  const discordChannel = useSelector(getCurrrentMatchDiscordChannel);
  const opponentTeamName = useSelector(getOpponentTeamName);
  const currentMatch = useSelector(getCurrentMatchRunning);
  const isPremium = useSelector(isPremiumUser);
  const isAuthenticated = useSelector(isAuth);
  const playerInfoPopupViewData = useSelector(getPopupByName(PLAYER_INFO_POPUP_VIEW));
  const tactics = useSelector(getStrategyTactics);
  const isLoading = useSelector(isFormationLoading);
  const { mindset, effort } = tactics;
  const active = useSelector(myTeamTactic);
  const playerInfoData = useSelector(getPlayerInformationSelector);

  const teamInfoPopupData = useSelector(getPopupByName(TEAM_INFO_POPUP));

  const [teamView, setTeamView] = useState('myTeam');

  const dispatch = useDispatch();


  const upcoming = useSelector(upcomingCalendarList);
  const currentTeam = useSelector(getMyCurrentTeam);
  const strategyLoading = useSelector(isStrategyLoading);

  const autoPickHandler = (e) => {
    if (isLoading) return;
    if (!isPremium) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      dispatch(showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP, POPUPS.MOBILE_REQUIRED_POPUP))
    } else {
      dispatch(setAutoFormation(STRATEGY_NAMES[MyStrategy]));
    }
  };





  return <>
    {!isEmpty(playerInfoPopupViewData) && createPortal(<PlayerInfoPopupView popupName={PLAYER_INFO_POPUP_VIEW} data={playerInfoData} isMobile={isMobile}/>, document.getElementById('modal') || document.body)}
    {!isEmpty(teamInfoPopupData) && createPortal(<TeamInfoPopup popupName={TEAM_INFO_POPUP}/>, document.getElementById('modal') || document.body)}
    <Header>
      <div><h1>Pick starting 11</h1><p>Set your formation, adjust tactics and select your best players for the next match.</p>
      </div>
      {isMatchLive(currentMatch) && <LiveMatchBar match={currentMatch} discordChannel={discordChannel} isAuthenticated={isAuthenticated}/>}
    </Header>
    <StrategyToolbar>
      <Actions>
        <Delegate>
          <span>Delegate to Chris{isAutoFormationEnabled == null ? ' · Status unavailable' : ''}</span>
          <StyledInfoDark iconsize="12" data-tip data-for="auto-pick-help"/>
          <StyledReactTooltip id="auto-pick-help" place="bottom">At the end of each match, Chris will pick the best eleven players for your next match.</StyledReactTooltip>
          <SwitchToggle id="auto-pick" toggled={Boolean(isAutoFormationEnabled)} onChange={autoPickHandler} isDisabled={isLoading}/>
        </Delegate>
        <ConfirmMatch label="Confirm lineup" activeItem={active} mindset={mindset} effort={effort}/>
      </Actions>
      {teamView === 'myTeam' ? <CaptainPanel /> : null}
      {teamView === 'myTeam' ? <StrategyPresets /> : null}

      <FormationViewTabs className="formations-section" role="group" aria-label="Formation view">
        <button type="button" aria-pressed={teamView==='myTeam'} onClick={()=>setTeamView('myTeam')}>Your formation</button>
        <button type="button" aria-pressed={teamView==='opponnentTeam'} onClick={()=>setTeamView('opponnentTeam')} title="Show the formation and players your opponent used in their last match">Opponent’s formation</button>
      </FormationViewTabs>
    </StrategyToolbar>
    <Pitch className={`football-container my-strategy-${MyStrategy} opponent-strategy-${OpponentStrategy}`}>
      <img className="pitch-art pitch-art--compact" src={compactFieldSrc} alt="" aria-hidden="true"/>
      <img className="pitch-art pitch-art--tall" src={tallFieldSrc} alt="" aria-hidden="true"/>
      <a className="sponsor" href="https://angelscup.com/" target="_blank" rel="noreferrer"><img src={img} alt="Angels Cup"/></a>
      {teamView==='myTeam' && <PitchActions><ChrisWand/><Clear type="button" disabled={!MyTeam.length || isLoading} onClick={()=>MyTeam.forEach(player=>dispatch(removePlayerFromStaff(player._id)))}>Clear all</Clear></PitchActions>}
      <div className="playing-field" style={{visibility:teamView==='myTeam'?'visible':'hidden'}}>
        <HomeTeam fullPitch strategy={MyStrategy} teamView={teamView} team={MyTeam} activeDraggingId={activeDraggingId}/>
      </div>
      {teamView==='opponnentTeam' && OpponentTeam && OpponentTeam.length>0 && <div className="playing-field away">
        <AwayTeam fullPitch strategy={OpponentStrategy} team={OpponentTeam} opponentTeamName={opponentTeamName}/>
      </div>}
    </Pitch>
    <Fixtures data-strategy-fixtures><HomeCalendar contained horizontal title="Next 3 matches" data={upcoming} teamId={currentTeam?._id} limit={3} isLoading={strategyLoading}/></Fixtures>
  </>;
}
